module.exports = window["bonnet-webcomponent-react-text-mask"];